/**
 * B2-RIDE - OpenAPI 3.0
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2.0.0
 * Contact: mobile@pikyrent.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Field to use for sorting news articles.
 */
export type NewsSortField = 'title' | 'publicationDate';

export const NewsSortField = {
    Title: 'title' as NewsSortField,
    PublicationDate: 'publicationDate' as NewsSortField
};